import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['unreadIndicator']
  static values = {
    commentId: Number,
    isUnread: Boolean,
    isOwnComment: Boolean,
    commentableType: String,
    commentableId: Number,
    markAsReadUrl: String
  }

  connect() {
    if (this.isUnreadValue && !this.isOwnCommentValue) {
      this.setupObserver()
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupObserver() {
    this.observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          this.markAsRead()
        }
      },
      {
        threshold: 0.5
      }
    )

    this.observer.observe(this.element)
  }

  async markAsRead() {
    this.observer.disconnect()

    try {
      const csrfToken = document.querySelector('[name="csrf-token"]')
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }

      if (csrfToken) {
        headers['X-CSRF-Token'] = csrfToken.content
      }

      const response = await fetch(this.markAsReadUrlValue, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          comment_id: this.commentIdValue,
          commentable_type: this.commentableTypeValue,
          commentable_id: this.commentableIdValue
        })
      })

      if (response.ok) {
        this.element.setAttribute('data-marked-as-read', 'true')
        this.hideUnreadIndicator()
      } else {
        console.error('Failed to mark comment as read:', response.status)
      }
    } catch (error) {
      console.error('Failed to mark comment as read:', error)
    }
  }

  hideUnreadIndicator() {
    if (!this.hasUnreadIndicatorTarget) {
      return
    }

    setTimeout(() => {
      this.unreadIndicatorTarget.classList.add('reporting-cycle-comments__unread-indicator--hiding')

      setTimeout(() => {
        this.unreadIndicatorTarget.remove()
      }, 300)
    }, 2000)
  }
}
